import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'Main' | 'AOSList';

/**
 * Errors related to the AOS page
 */
export const Errors = createErrors<Page, Component>('AOS')({
    Main: {
        GetUserInfoError: {
            severity: 'MEDIUM',
            message: 'Failed to get user information from Okta.',
        },
        FetchCustomersError: {
            severity: 'MEDIUM',
            message: 'Failed to fetch customers from AOS.',
        },
        GetTokenError: {
            severity: 'MEDIUM',
            message: 'Failed to get token.',
        },
    },
    AOSList: {
        MergeCartError: {
            severity: 'MEDIUM',
            message: 'Failed to merge cart.',
        },
        FetchUserError: {
            severity: 'MEDIUM',
            message: 'Failed to fetch user information.',
        },
    },
});
